import React, {useCallback, useState} from 'react'
import {useDropzone} from 'react-dropzone'

function ImageDropzone({value, setImage, register}) {
  const [file, setFile] = useState(null)
  const [preview, setPreview] = useState(null)

  const [loading, setLoading] = useState(null)

  const onDrop = useCallback(
    (acceptedFiles) => {
      // console.log('acceptedFiles', acceptedFiles)
      // setLoading(true)
      setFile(acceptedFiles[0])
      setImage(acceptedFiles[0])
      // setLoading(false)
      setPreview(URL.createObjectURL(acceptedFiles[0]))
    },
    [setFile, setImage]
  )

  function resetImage() {
    setFile(null)
    setImage(null)
  }

  const {getRootProps, getInputProps, isDragAccept, isDragReject} = useDropzone({
    onDrop,
    multiple: false,
    accept: {
      'image/png': ['.png'],
      'image/jpg': ['.jpg'],
      'image/jpeg': ['.jpeg'],
    },
  })

  // console.log('isDragAccept')
  // console.log(isDragAccept)
  // console.log('isDragReject')
  // console.log(isDragReject)
  // console.log(register)
  return (
    <div className='all-center'>
      <div
        {...getRootProps()}
        className={
          ' p-6 dropzone ' +
          (isDragReject === true ? ' borderRejected ' : '') +
          (isDragAccept === true ? ' borderAccepted ' : '')
        }
      >
        <input {...getInputProps()} />

        <div className='all-center-column'>
          {isDragReject ? (
            <>
              <svg width={120} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'>
                <path
                  fill='#DCDCDC'
                  d='M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256z'
                />
              </svg>
              <br />
              <h2 className='title text-muted text-center '>
                Este tipo de arquivo não é suportado
              </h2>
            </>
          ) : isDragAccept ? (
            <>
              <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' width={120}>
                <path
                  fill='#DCDCDC'
                  d='M243.8 339.8C232.9 350.7 215.1 350.7 204.2 339.8L140.2 275.8C129.3 264.9 129.3 247.1 140.2 236.2C151.1 225.3 168.9 225.3 179.8 236.2L224 280.4L332.2 172.2C343.1 161.3 360.9 161.3 371.8 172.2C382.7 183.1 382.7 200.9 371.8 211.8L243.8 339.8zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 48C141.1 48 48 141.1 48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48z'
                />
              </svg>
              <br />
              <h2 className='title text-muted text-center'>Solte sua imagem para ser carregada.</h2>
            </>
          ) : value ? (
            <div className='w-100 all-center- column'>
              <div className='all-center-collumn w-100'>
                <div>
                  <img src={preview} width='100%' height='100%' alt='' />
                </div>
                <div className='all-center mrt-1'>
                  <button className='btn btn-sm btn-danger' onClick={resetImage}>
                    Excluir
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <>
              <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' width={120}>
                <path
                  fill='#DCDCDC'
                  d='M152 120c-26.51 0-48 21.49-48 48s21.49 48 48 48s48-21.49 48-48S178.5 120 152 120zM447.1 32h-384C28.65 32-.0091 60.65-.0091 96v320c0 35.35 28.65 64 63.1 64h384c35.35 0 64-28.65 64-64V96C511.1 60.65 483.3 32 447.1 32zM463.1 409.3l-136.8-185.9C323.8 218.8 318.1 216 312 216c-6.113 0-11.82 2.768-15.21 7.379l-106.6 144.1l-37.09-46.1c-3.441-4.279-8.934-6.809-14.77-6.809c-5.842 0-11.33 2.529-14.78 6.809l-75.52 93.81c0-.0293 0 .0293 0 0L47.99 96c0-8.822 7.178-16 16-16h384c8.822 0 16 7.178 16 16V409.3z'
                />
              </svg>

              <br />
              <h2 className='title text-muted text-center'>Clique ou arraste sua imagem aqui.</h2>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default ImageDropzone
